// Helper Functions

const onlyNumbers = (cpf: string) => cpf.replace(/\D/g, '');
const pad = (cpf: string) => ('0'.repeat(11) + cpf).slice(-11);

// Helper

const CPFHelper = {
  onlyNumbers: onlyNumbers,
  pad: pad,
};

// Export

export default CPFHelper;
